/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BulbCommonModule } from 'src/common/bulb-common.module';
import { AeroModule } from 'src/aero/aero.module';
import { TranslocoModule } from '@jsverse/transloco';
import { AssignPageDialogComponent } from './assign-page-dialog/assign-page-dialog.component';
import { AssignmentHttpService } from './assignment-http.service';

/**
 * Module for handling components related to Assignments.
 */
@NgModule({
  declarations: [
    AssignPageDialogComponent,
  ],
  imports: [
    AeroModule,
    BulbCommonModule,
    CommonModule,
    FormsModule,
    TranslocoModule,
  ],
  providers: [AssignmentHttpService],
})
export class AssignmentModule { }
